import React from "react";
import { MenuItem } from "@mui/material";
import { DropdownMenu, type DropdownMenuProps } from "@packsize/components";
import LanguageIcon from "@mui/icons-material/Language";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import type { SelectionSource } from "../../schemas";
import { useLocale } from "../../hooks/use-locale";

interface LocaleDropdownProps extends Omit<DropdownMenuProps, "label" | "children"> {
	readonly mode: Exclude<SelectionSource, "system">;
}

export const LocaleDropdown: React.FC<LocaleDropdownProps> = ({ mode, buttonProps, popoverProps }) => {
	const { currentLocale, locales, setLocale } = useLocale();

	if (locales.length <= 1) {
		return null;
	}

	const currentLabel = locales.find((l) => l.key === currentLocale.locale)?.label ?? currentLocale.locale;

	return (
		<DropdownMenu
			label={currentLabel}
			buttonProps={{
				variant: "outlined",
				startIcon: <LanguageIcon sx={{ color: "text.primary" }} />,
				endIcon: <KeyboardArrowDownIcon sx={{ color: "text.primary" }} />,
				color: "info",
				...buttonProps,
				sx: {
					backgroundColor: "background.paper",
					color: "text.primary",
					...buttonProps?.sx,
				},
			}}
			popoverProps={popoverProps}
		>
			{locales.map((locale) => (
				<MenuItem
					key={locale.key}
					selected={locale.key === currentLocale.locale}
					onClick={() => setLocale(locale.key, mode)}
					data-testid={`locale-dropdown__item__${locale.key}`}
				>
					{locale.label}
				</MenuItem>
			))}
		</DropdownMenu>
	);
};
